<script>
    import Card from "../../Components/Card/Card.svelte";
    import TextArrow from "../../Components/TextArrow/TextArrow.svelte";
    import pattern_2 from "../../../public/src/svg/Patterns/pattern_2.svelte";

    import Button from "../../Components/Button/Button.svelte";
    import { User, getNews, russianMonths } from "../../store";
    
    let user;
    let showContent = false;
    let news = [];

    User.subscribe((value) => {
        user = value;
    });

    function addNews() {
        window.location.pathname = "/news/add";
    }

    getNews("/news").then((response) => {
        news = response;
        showContent = true;
    });

    function getFormatedDate(myDate){
        let date = new Date(myDate);
        return `${date?.getDate()} ${russianMonths[date?.getMonth()]} ${date?.getFullYear()}`;
    }

</script>

<div id="content">
    <div class="pattern-block" style="margin-bottom: 20px;">
        <div class="pattern">
            <svelte:component this={pattern_2} />
        </div>
    </div>
    {#if user?.role == "1"}
        <div class="buttons">
            <Button on:click={addNews}>Добавить</Button>
        </div>
    {/if}
    <TextArrow showArrow={false} text={"События"} />
    <div class="news">
        {#each news as item}
            <Card src={item[5]} link={"/news/" + item[0]}>
                <a class="pointer" href={"/news/" + item[0]} style="margin: 5px; font-size: large;">
                    {item[2]}
                </a>
                <div class="small" style="margin: 5px; opacity: 0.8;">
                    {getFormatedDate(item[8])}
                </div>
            </Card>
        {/each}
    </div>
</div>

<style lang="less" global>
    @import "events.less";
</style>
